<template>
    <div class="productaddress">
        <!-- 訂購人 -->
        <v-card class="my-3">
            <v-list-item class="title__stys">
                <v-list-item-content class="white--text title__sty">{{$t('ProductAddress_title1')}}</v-list-item-content>
                <v-list-item-action>
                    <v-dialog
                        v-model="show_area.order_dialog"
                        persistent
                        width="500"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn depressed color="white" v-on="on" v-show="!show_area.order_is_first">
                                {{$t('edit_button')}}
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title class="headline">{{$t('ProductAddress_title2')}}</v-card-title>
                            <v-card-text>
                                <v-text-field
                                    :label="$t('name_input')"
                                    :placeholder="$t('ProductAddress_input1')"
                                    v-model="edit_user_info.name"
                                />
                                <v-text-field
                                    :label="$t('email_input')"
                                    :placeholder="$t('ProductAddress_input2')"
                                    v-model="edit_user_info.email"
                                />
                                <v-text-field
                                    :label="$t('phone_input')"
                                    :placeholder="$t('ProductAddress_input3')"
                                    v-model="edit_user_info.mobile"
                                />
                                <p class="mb-2">{{$t('ProductAddress_input4')}}</p>
                                <v-radio-group
                                    v-model="edit_user_info.address_type"
                                    @change="onOrderChange($event)"
                                    v-for="(item) in addressTypeArr"
                                    :key="'labelA'+item.label"
                                    class="mt-0"
                                >
                                    <v-radio
                                        :label="item.label"
                                        :value="item.value"
                                    ></v-radio>
                                </v-radio-group>
                                <!-- 選擇公司 -->
                                <div v-show="show_area.order_company_show">
                                    <v-text-field
                                        v-model="edit_user_info.company_address"
                                        :label="$t('ProductAddress_input5')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="edit_user_info.company_name"
                                        :label="$t('ProductAddress_input6')"
                                    ></v-text-field>
                                </div>
                                <!-- 選擇其他地址 -->
                                <div v-show="show_area.order_home_show">
                                    <v-row align="center">
                                    <v-col class="d-flex" cols="6">
                                        <div class="select_sty">
                                        <select v-model="edit_user_info.city" @change="onOrderAreaChange">
                                        <option value="">{{$t('ProductAddress_text1')}}</option>
                                        <option v-for="product in area.area_lists" :key="product">
                                            {{ product }}
                                        </option>
                                        </select>
                                        </div>
                                    </v-col>
                                    <v-col class="d-flex" cols="6">
                                        <div class="select_sty">
                                        <select v-model="edit_user_info.area">
                                            <option value="">{{$t('ProductAddress_text2')}}</option>
                                            <option v-for="detail in area.area_detail[edit_user_info.city]" :key="detail">{{ detail }}</option>
                                        </select>
                                        </div>
                                    </v-col>
                                    </v-row>
                                    <p>{{$t('ProductAddress_text3')}}</p>
                                    <v-text-field
                                    v-model="edit_user_info.address"
                                    :label="$t('ProductAddress_input4')"
                                    ></v-text-field>
                                </div>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    @click="show_area.order_dialog = false;"
                                >
                                    {{$t('cancel_button')}}
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    @click="checkOrderAddress"
                                >
                                    {{$t('ok_button2')}}
                                </v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <!-- 第一次訂購 -->
            <div class="text-center">
                <v-btn
                    outlined
                    color="error"
                    class="my-3"
                    @click="show_area.order_dialog = true;"
                    v-show="show_area.order_is_first"
                >
                <v-icon left>mdi-pencil</v-icon> {{$t('ProductAddress_button1')}}
                </v-btn>
            </div>
            <!-- 訂購人資訊 -->
            <div v-show="!show_area.order_is_first">
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{$t('name_input')}}：{{ user_info.name }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{$t('phone_input')}}：{{ user_info.mobile }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{$t('email_input')}}：{{ user_info.email }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{$t('address_input')}}：{{ maxaddress.order_max_address }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
            </div>
        </v-card>
        <!-- 收貨人 -->
        <v-card class="mb-3">
            <v-list-item class="title__stys">
                <v-list-item-content class="white--text title__sty">{{$t('ProductAddress_title3')}}</v-list-item-content>
                <v-checkbox
                    :label="$t('ProductAddress_button2')"
                    @change="sameOrderData"
                    color="white"
                    class="mr-3 checkbox__sty"
                />
                <v-list-item-action>
                    <v-dialog
                        v-model="show_area.rec_dialog"
                        persistent
                        width="500"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn depressed color="white" v-on="on" v-show="!show_area.rec_is_first">
                                {{$t('edit_button')}}
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title class="headline">{{$t('ProductAddress_title4')}}</v-card-title>
                            <v-card-text>
                                <v-text-field
                                    :label="$t('name_input')"
                                    :placeholder="$t('ProductAddress_input1')"
                                    v-model="edit_user_info.rec_name"
                                />
                                <v-text-field
                                    :label="$t('email_input')"
                                    :placeholder="$t('ProductAddress_input2')"
                                    v-model="edit_user_info.rec_email"
                                />
                                <v-text-field
                                    :label="$t('phone_input')"
                                    :placeholder="$t('ProductAddress_input3')"
                                    v-model="edit_user_info.rec_mobile"
                                />
                                <p class="mb-2">{{$t('ProductAddress_input7')}}</p>
                                <v-radio-group
                                    v-model="edit_user_info.rec_address_type"
                                    @change="onRecChange($event)"
                                    v-for="(item) in addressTypeArr"
                                    :key="'labelB'+item.label"
                                    class="mt-0"
                                >
                                    <v-radio
                                        :label="item.label"
                                        :value="item.value"
                                    ></v-radio>
                                </v-radio-group>
                                <!-- 選擇公司 -->
                                <div v-show="show_area.rec_company_show">
                                    <v-text-field
                                    v-model="edit_user_info.rec_company_address"
                                    :label="$t('ProductAddress_input5')"
                                    ></v-text-field>
                                    <v-text-field
                                    v-model="edit_user_info.rec_company_name"
                                    :label="$t('ProductAddress_input6')"
                                    ></v-text-field>
                                </div>
                                <!-- 選擇其他地址 -->
                                <div v-show="show_area.rec_home_show">
                                    <v-row align="center">
                                    <v-col class="d-flex" cols="6">
                                        <div class="select_sty">
                                        <select v-model="edit_user_info.rec_city" @change="onRecAreaChange">
                                        <option value="">{{$t('ProductAddress_text1')}}</option>
                                        <option v-for="product in area.area_lists" :key="product">
                                            {{ product }}
                                        </option>
                                        </select>
                                        </div>
                                    </v-col>
                                    <v-col class="d-flex" cols="6">
                                        <div class="select_sty">
                                        <select v-model="edit_user_info.rec_area">
                                            <option value="">{{$t('ProductAddress_text2')}}</option>
                                            <option v-for="detail in area.area_detail[edit_user_info.rec_city]" :key="detail">{{ detail }}</option>
                                        </select>
                                        </div>
                                    </v-col>
                                    </v-row>
                                    <p>{{$t('ProductAddress_text3')}}</p>
                                    <v-text-field
                                    v-model="edit_user_info.rec_address"
                                    :label="$t('ProductAddress_input7')"
                                    ></v-text-field>
                                </div>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    @click="show_area.rec_dialog = false;"
                                >
                                    {{$t('cancel_button')}}
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    @click="checkRecAddress"
                                >
                                    {{$t('ok_button2')}}
                                </v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-list-item-action>
            </v-list-item>
            <!-- 同訂購人資料 -->
            <!--  -->
            <v-divider></v-divider>
            <!-- 第一次訂購 -->
            <div class="text-center">
                <v-btn
                    outlined
                    color="error"
                    class="my-3"
                    @click="show_area.rec_dialog = true"
                    v-show="show_area.rec_is_first"
                >
                    <v-icon left>mdi-pencil</v-icon> {{$t('ProductAddress_button3')}}
                </v-btn>
            </div>
            <!-- 收貨人資訊 -->
            <div v-show="!show_area.rec_is_first">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{$t('name_input')}}：{{ user_info.rec_name }}</v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{$t('phone_input')}}：{{ user_info.rec_mobile }}</v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{$t('email_input')}}：{{ user_info.rec_email }}</v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>{{$t('address_input')}}：{{ maxaddress.rec_max_address }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'addressInput',
    props: ['getuserinfodata'],

    data: function () {
        return {
            user_info: this.getuserinfodata[0],
            edit_user_info: this.getuserinfodata[0],
            area: {
                'area_lists': [],
                'area_detail': [],
            },
            show_area: {
                // order
                'order_is_first': true,
                'order_dialog': false,
                // order address choose
                'order_company_show': false,
                'order_home_show': false,
                // rec
                'rec_is_first': true,
                'rec_dialog': false,
                // rec address choose
                'rec_company_show': false,
                'rec_home_show': false,
            },
            maxaddress: {
                'order_max_address': '',
                'rec_max_address': '',
            },
            // 運送種類
            addressTypeArr: [
                {
                    // 依公司地址
                    label: this.$t('ProductAddress_input8'),
                    value: 2
                },
                {
                    // 其他地址
                    label: this.$t('ProductAddress_input9'),
                    value: 1
                }
            ]
        }
    },
    methods: {
        async getUserInfo() {
            // 訂購人
            // 0: 沒有訂過 1: 個人地址 2: 公司地址
            if (this.getuserinfodata[0].address_type === 1) {
                this.show_area.order_is_first = false;
                this.maxaddress.order_max_address = this.getuserinfodata[0].city + this.getuserinfodata[0].area + this.getuserinfodata[0].address;
            } else if (this.getuserinfodata[0].address_type === 2) {
                this.show_area.order_is_first = false;
                this.maxaddress.order_max_address = `${this.getuserinfodata[0].company_address}(${this.getuserinfodata[0].company_name})`;
            } else {
                this.show_area.order_is_first = true;
                this.maxaddress.order_max_address = '';
            }
            // 儲存訂購人地址
            let orderinfo_data = [];
            orderinfo_data.push({
                'order_name': this.getuserinfodata[0].name,
                'order_address': this.maxaddress.order_max_address
            });
            // store vuex
            this.$store.commit({
                type: 'setOrderinfoData',
                orderinfoData: orderinfo_data,
            });
            // 更改編輯訂購人地址 radio button
            await this.onOrderChange(this.getuserinfodata[0].address_type);
            // 收貨人
            // 0: 沒有 1: 個人地址 2: 公司地址
            if (this.getuserinfodata[0].rec_address_type === 1) {
                this.show_area.rec_is_first = false;
                this.maxaddress.rec_max_address = this.getuserinfodata[0].rec_city + this.getuserinfodata[0].rec_area + this.getuserinfodata[0].rec_address;
            } else if (this.getuserinfodata[0].rec_address_type === 2) {
                this.show_area.rec_is_first = false;
                this.maxaddress.rec_max_address = `${this.getuserinfodata[0].rec_company_address}(${this.getuserinfodata[0].rec_company_name})`;
            } else {
                this.show_area.rec_is_first = true;
                this.maxaddress.rec_max_address = '';
            }
            // 儲存收件人地址
            let recinfo_data = [];
            recinfo_data.push({
                'rec_name': this.getuserinfodata[0].rec_name,
                'rec_address': this.maxaddress.rec_max_address
            });
            // store vuex
            this.$store.commit({
                type: 'setRecinfoData',
                recinfoData: recinfo_data,
            });
            // 更改編輯收件人地址 radio button
            await this.onRecChange(this.getuserinfodata[0].rec_address_type);
            // 縣市區域 api
            await this.getAreaInfo();
        },
        onOrderChange(event) {
            if (event === 1) {
                this.show_area.order_company_show = false;
                this.show_area.order_home_show = true;
            } else if (event === 2) {
                this.show_area.order_company_show = true;
                this.show_area.order_home_show = false;
            } else {
                this.show_area.order_company_show = false;
                this.show_area.order_home_show = false;
            }
        },
        onRecChange(event) {
            if (event === 1) {
                this.show_area.rec_company_show = false;
                this.show_area.rec_home_show = true;
            } else if (event === 2) {
                this.show_area.rec_company_show = true;
                this.show_area.rec_home_show = false;
            } else {
                this.show_area.rec_company_show = false;
                this.show_area.rec_home_show = false;
            }
        },
        // 縣市區域 api
        getAreaInfo() {
            this.axios({
                method: 'post',
                url: 'https://shopbkd.cheerlife.io/cheerlife/v1/recommend/city-area',
                data: {
                    access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
                },
            })
                .then((response) => {
                    if (response.status === 200) {
                        this.area.area_lists = response.data.area_lists;
                        this.area.area_detail = response.data.area_detail;
                    } else {
                        alert(response.data.message);
                        return false;
                    }
                })
                .catch((error) => {
                    alert(`status code: ${ error.response.status }`);
                    alert(error.response.data);
                });
        },
        // 更改區域
        onOrderAreaChange() {
            this.edit_user_info.area = '';
        },
        onRecAreaChange() {
            this.edit_user_info.rec_area = '';
        },
        // 儲存訂購人變更
        checkOrderAddress() {
            this.user_info = {};
            this.user_info = this.edit_user_info;
            // 訂購人資訊總和地址更改
            if (this.edit_user_info.address_type === 1) {
                this.maxaddress.order_max_address = this.edit_user_info.city + this.edit_user_info.area + this.edit_user_info.address;
            } else if (this.edit_user_info.address_type === 2) {
                this.maxaddress.order_max_address = `${this.edit_user_info.company_address}(${this.edit_user_info.company_name})`;
            } else {
                this.maxaddress.order_max_address = '';
            }
            // vuex store
            // 修改訂購人綜合地址
            this.$store.state.orderinfo.orderinfoData[0].order_name = this.edit_user_info.name;
            this.$store.state.orderinfo.orderinfoData[0].order_address = this.maxaddress.order_max_address;
            // 訂購人資訊
            this.$store.state.userinfo.userinfoData[0].name = this.edit_user_info.name;
            this.$store.state.userinfo.userinfoData[0].email = this.edit_user_info.email;
            this.$store.state.userinfo.userinfoData[0].mobile = this.edit_user_info.mobile;
            this.$store.state.userinfo.userinfoData[0].address_type = this.edit_user_info.address_type;
            this.$store.state.userinfo.userinfoData[0].city = this.edit_user_info.city;
            this.$store.state.userinfo.userinfoData[0].area = this.edit_user_info.area;
            this.$store.state.userinfo.userinfoData[0].address = this.edit_user_info.address;
            this.$store.state.userinfo.userinfoData[0].company_name = this.edit_user_info.company_name;
            this.$store.state.userinfo.userinfoData[0].company_address = this.edit_user_info.company_address;
            // 按鈕關閉
            this.show_area.order_is_first = false;
            this.show_area.order_dialog = false;
        },
        // 儲存收貨人變更
        checkRecAddress() {
            this.user_info = {};
            this.user_info = this.edit_user_info;
            if (this.edit_user_info.rec_address_type === 1) {
                this.maxaddress.rec_max_address = this.edit_user_info.rec_city + this.edit_user_info.rec_area + this.edit_user_info.rec_address;
            } else if (this.edit_user_info.rec_address_type === 2) {
                this.maxaddress.rec_max_address = `${this.edit_user_info.rec_company_address}(${this.edit_user_info.rec_company_name})`;
            } else {
                this.maxaddress.rec_max_address = '';
            }
            // vuex store
            // 修改收貨人綜合地址
            this.$store.state.recinfo.recinfoData[0].rec_name = this.edit_user_info.rec_name;
            this.$store.state.recinfo.recinfoData[0].rec_address = this.maxaddress.rec_max_address;
            // 收貨人資訊
            this.$store.state.userinfo.userinfoData[0].rec_name = this.edit_user_info.rec_name;
            this.$store.state.userinfo.userinfoData[0].rec_email = this.edit_user_info.rec_email;
            this.$store.state.userinfo.userinfoData[0].rec_mobile = this.edit_user_info.rec_mobile;
            this.$store.state.userinfo.userinfoData[0].rec_address_type = this.edit_user_info.rec_address_type;
            this.$store.state.userinfo.userinfoData[0].rec_city = this.edit_user_info.rec_city;
            this.$store.state.userinfo.userinfoData[0].rec_area = this.edit_user_info.rec_area;
            this.$store.state.userinfo.userinfoData[0].rec_address = this.edit_user_info.rec_address;
            this.$store.state.userinfo.userinfoData[0].rec_company_name = this.edit_user_info.rec_company_name;
            this.$store.state.userinfo.userinfoData[0].rec_company_address = this.edit_user_info.rec_company_address;
            // 按鈕關閉
            this.show_area.rec_is_first = false;
            this.show_area.rec_dialog = false;
        },
        // 收貨人資訊同訂購人資訊
        sameOrderData(event) {
            if (event === true) {
                // 收貨人資訊顯示
                this.user_info.rec_address = this.user_info.address;
                this.user_info.rec_address_type = this.user_info.address_type;
                this.user_info.rec_area = this.user_info.area;
                this.user_info.rec_city = this.user_info.city;
                this.user_info.rec_company_address = this.user_info.company_address;
                this.user_info.rec_company_name = this.user_info.company_name;
                this.user_info.rec_email = this.user_info.email;
                this.user_info.rec_info_exist = this.user_info.user_info_exist;
                this.user_info.rec_mobile = this.user_info.mobile;
                this.user_info.rec_name = this.user_info.name;
                // 綜合地址
                if (this.user_info.rec_address_type === 1) {
                    this.maxaddress.rec_max_address = this.user_info.rec_city + this.user_info.rec_area + this.user_info.rec_address;
                } else if (this.user_info.rec_address_type === 2) {
                    this.maxaddress.rec_max_address = `${this.user_info.rec_company_address}(${this.user_info.rec_company_name})`;
                } else {
                    this.maxaddress.rec_max_address = '';
                }
                // 收貨人編輯頁
                this.edit_user_info.rec_address = this.user_info.address;
                this.edit_user_info.rec_address_type = this.user_info.address_type;
                this.edit_user_info.rec_area = this.user_info.area;
                this.edit_user_info.rec_city = this.user_info.city;
                this.edit_user_info.rec_company_address = this.user_info.company_address;
                this.edit_user_info.rec_company_name = this.user_info.company_name;
                this.edit_user_info.rec_email = this.user_info.email;
                this.edit_user_info.rec_info_exist = this.user_info.user_info_exist;
                this.edit_user_info.rec_mobile = this.user_info.mobile;
                this.edit_user_info.rec_name = this.user_info.name;
                // 更改編輯訂購人地址 radio button
                this.onRecChange(this.edit_user_info.address_type);
                // vuex store
                // 修改收貨人綜合地址
                this.$store.state.recinfo.recinfoData[0].rec_name = this.user_info.name;
                this.$store.state.recinfo.recinfoData[0].rec_address = this.maxaddress.rec_max_address;
                // 收貨人資訊
                this.$store.state.userinfo.userinfoData[0].rec_name = this.user_info.name;
                this.$store.state.userinfo.userinfoData[0].rec_email = this.user_info.email;
                this.$store.state.userinfo.userinfoData[0].rec_mobile = this.user_info.mobile;
                this.$store.state.userinfo.userinfoData[0].rec_address_type = this.user_info.address_type;
                this.$store.state.userinfo.userinfoData[0].rec_city = this.user_info.city;
                this.$store.state.userinfo.userinfoData[0].rec_area = this.user_info.area;
                this.$store.state.userinfo.userinfoData[0].rec_address = this.user_info.address;
                this.$store.state.userinfo.userinfoData[0].rec_company_name = this.user_info.company_name;
                this.$store.state.userinfo.userinfoData[0].rec_company_address = this.user_info.company_address;
                // 第一次使用按鈕關閉
                this.show_area.rec_is_first = false;
            } else {
                // console.log(this.$store.state.userinfo.userinfoData);
                // 顯示
                this.user_info.rec_address = '';
                this.user_info.rec_address_type = this.$store.state.userinfo.userinfoData[0].rec_address_type;
                this.user_info.rec_area = '';
                this.user_info.rec_city = '';
                this.user_info.rec_company_address = '';
                this.user_info.rec_company_name = '';
                this.user_info.rec_email = '';
                this.user_info.rec_info_exist = this.$store.state.userinfo.userinfoData[0].rec_info_exist;
                this.user_info.rec_mobile = '';
                this.user_info.rec_name = '';
                // 綜合地址
                this.maxaddress.rec_max_address = '';
                // 收貨人編輯頁
                this.edit_user_info.rec_address = '';
                this.edit_user_info.rec_address_type = this.$store.state.userinfo.userinfoData[0].rec_address_type;
                this.edit_user_info.rec_area = '';
                this.edit_user_info.rec_city = '';
                this.edit_user_info.rec_company_address = '';
                this.edit_user_info.rec_company_name = '';
                this.edit_user_info.rec_email = '';
                this.edit_user_info.rec_info_exist = this.$store.state.userinfo.userinfoData[0].rec_info_exist;
                this.edit_user_info.rec_mobile = '';
                this.edit_user_info.rec_name = '';
                // 更改編輯訂購人地址 radio button
                this.onRecChange(this.edit_user_info.rec_address_type);
                // 收貨人資訊
                this.$store.state.userinfo.userinfoData[0].rec_name = '';
                this.$store.state.userinfo.userinfoData[0].rec_email = '';
                this.$store.state.userinfo.userinfoData[0].rec_mobile = '';
                this.$store.state.userinfo.userinfoData[0].rec_city = '';
                this.$store.state.userinfo.userinfoData[0].rec_area = '';
                this.$store.state.userinfo.userinfoData[0].rec_address = '';
                this.$store.state.userinfo.userinfoData[0].rec_company_name = '';
                this.$store.state.userinfo.userinfoData[0].rec_company_address = '';
                // 第一次使用按鈕開啟
                this.show_area.rec_is_first = true;
            }
        }
    },
    mounted() {
        this.getUserInfo();
    },
    watch: {
    },
};
</script>
<style lang="sass">
    .radio__sty .v-messages
        min-height: unset
    .checkbox__sty .theme--light.v-label, .checkbox__sty .theme--light.v-icon
        color: #ffffff
</style>
<style scoped lang="sass">
    .title__stys
        background-color: #352D40
    .title__sty
        font-weight: bold
        font-size: 15px
        letter-spacing: 0.1em
    .subtitle__sty
        background: #D2DDF0
        color: #352D40
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
    .addressinfo__sty p
        color: #352D40
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
    .addressinfo__sty > p > span font
        visibility: hidden
    .btn__sty
        background-color: #352D40 !important
        color: #ffffff
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
    // select
    select
        -webkit-appearance: none
        -moz-appearance: none
        -ms-appearance: none
        appearance: none
        outline: 0
        box-shadow: none
        border: 0 !important
        background: #2c3e50
        background-image: none
    select::-ms-expand
        display: none
    .select_sty
        position: relative
        display: flex
        width: 20em
        height: 3em
        line-height: 3
        background: #2c3e50
        overflow: hidden
        border-radius: .25em
    select
        flex: 1
        padding: 0 .5em
        color: #fff
        cursor: pointer
    .select_sty::after
        content: '\25BC'
        position: absolute
        top: 0
        right: 0
        padding: 0 1em
        background: #34495e
        color: #ffffff
        cursor: pointer
        pointer-events: none
        -webkit-transition: .25s all ease
        -o-transition: .25s all ease
        transition: .25s all ease
    .select_sty:hover::after
        color: #f39c12
</style>
